<template>
  <div class="d-flex flex-column">
    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>

    <div class="top-header d-flex flex-row align-center justify-space-between">
      <div class="d-flex flex-row align-center">
        <router-link :to="{ name: 'trucks_list' }">
          <v-btn icon>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </router-link>
        <span>Create Truck</span>
      </div>
    </div>

    <v-sheet class="mt-2">
      <v-form class="main-form pa-3" ref="form">
        <v-container>
          <v-row>
            <v-col cols="12" sm="4">
              <v-autocomplete
                label="Brand-Model"
                v-model="truck.model"
                dense
                outlined
                :items="modelNames"
                :rules="[rules.required]"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                label="Manufacturer-Model"
                v-model="truck.engineModel"
                dense
                outlined
                :items="engineModelNames"
                :rules="[rules.required]"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Vin"
                v-model="truck.vin"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Wheel base"
                v-model="truck.wheelBase"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Exterior color"
                v-model="truck.exterior_color"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Interior color"
                v-model="truck.interior_color"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Mileage"
                v-model="truck.mileage"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                  label="Transmission"
                  v-model="truck.transmission"
                  dense
                  outlined
                  :rules="[rules.required]"
                  :items="transmissions"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Year"
                v-model="truck.year"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                  label="Stock Number"
                  v-model="truck.stock"
                  dense
                  outlined
                  :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                  label="Price"
                  v-model="truck.price"
                  dense
                  outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                label="Status"
                v-model="truck.status"
                dense
                outlined
                :items="status"
                :rules="[rules.required]"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                  label="YouTube"
                  v-model="truck.youtube"
                  dense
                  outlined
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col
                cols="12"
                md="12"
            >
              <v-textarea
                  outlined
                  label="Description"
                  v-model="truck.description"
              ></v-textarea>
            </v-col>
          </v-row>

          <div class="d-flex flex-row align-center justify-end">
            <v-btn
              class="text-capitalize white--text"
              color="primary"
              tile
              depressed
              @click="createTruck()"
            >
              <img
                class="mr-1"
                width="28px"
                height="28px"
                src="/icons/plus.svg"
              />
              {{ $t("Create") }}
            </v-btn>
          </div>
        </v-container>
      </v-form>
    </v-sheet>
  </div>
</template>
<script>
import RestResourceAuth from "@/api/apiAuthService";
import { ResponseStatus } from "@/models/ResponseStatusEnum";
import RestResourceBrand from "../../api/apiBrandService";
import RestResourceModel from "../../api/apiModelService";
import RestResourceTruck from "../../api/apiTruckService";
import RestResourceEngineModel from "../../api/apiEngineModelService";

export default {
  name: "NewAccount",
  data() {
    return {
      transmissions: ['MANUAL', 'AUTOMATIC'],
      creating: false,
      errorAlert: false,
      errorMsg: "",
      models: [],
      engineModels: [],
      name: "",
      status: ["COMING_SOON", "IN_STORE"],
      truck: {
        model: "",
        engineModel: "",
        vin: "",
        mileage: "",
        // eslint-disable-next-line @typescript-eslint/camelcase
        exterior_color: "",
        // eslint-disable-next-line @typescript-eslint/camelcase
        interior_color: "",
        transmission: "",
        wheelBase: "",
        status: "",
        youtube: "",
        year: "",
        stock: "",
        price: "",
        description: ""
      },
      rules: {
        email: v => {
          const re = /^(([^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+(\.[^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (re.test(v)) return true;
          return this.$t("errors.mustBeValidEmail");
        },
        required: v => {
          if (v) {
            return true;
          }
          return this.$t("errors.requiredField");
        },
        pass: v => v.length >= 8 || this.$t("errors.shortPassword")
      }
    };
  },
  computed: {
    modelNames() {
      return this.models.map(model => `${model.brand.name}-${model.name}`);
    },
    engineModelNames() {
      return this.engineModels.map(
        model => `${model.manufacturer.name}-${model.name}`
      );
    }
  },
  async created() {
    await this.getModels();
  },
  methods: {
    async getModels() {
      try {
        const params = {
          skip: 0,
          limit: -1
        };
        const resp = await RestResourceModel.prototype.getModels(params);
        if (resp) {
          this.models = resp.data.data;
          const resp1 = await RestResourceEngineModel.prototype.getModels(
            params
          );
          this.engineModels = resp1.data.data;
        }
      } catch (error) {
        alert("ERROR:\n\t" + error.response.data.message);
        throw error;
      }
    },
    createTruck() {
      if (this.$refs.form.validate()) {
        this.creating = true;
        const modelId = this.models.find(
          m => m.name === this.truck.model.split("-")[1]
        )._id;
        const engineModelId = this.engineModels.find(
          m => m.name === this.truck.engineModel.split("-")[1]
        )._id;
        const body = {
          modelId,
          engineModelId,
          mileage: this.truck.mileage,
          condition: this.truck.condition,
          transmission: this.truck.transmission,
          drivetrain: this.truck.drivetrain,
          // eslint-disable-next-line @typescript-eslint/camelcase
          exterior_color: this.truck.exterior_color,
          // eslint-disable-next-line @typescript-eslint/camelcase
          interior_color: this.truck.interior_color,
          status: this.truck.status,
          vin: this.truck.vin,
          wheelBase: this.truck.wheelBase,
          year: this.truck.year,
          stock: this.truck.stock,
          price: this.truck.price,
          description: this.truck.description,
          youtube: this.truck.youtube
        };
        RestResourceTruck.prototype
          .postTruck(body)
          .then(() => {
            this.$router.push({ name: "trucks_list" });
          })
          .catch(error => {
            this.errorMsg = error.response.data.message;
            this.errorAlert = true;
            this.creating = false;
          })
          .finally(() => {
            this.creating = false;
          });
      }
    }
  }
};
</script>
<style></style>
